// extracted by mini-css-extract-plugin
export default {"form":"form___kkW_g","input":"input___OKfLA","buttonContainer":"buttonContainer___SHtOm","button":"button___s0b6x","icon":"icon___ZXOj6"};